.banner {
  z-index: 1000;
  padding: 8px 12px;
  text-align: center;
  width: 100%;
}

.info {
  background: #eef5ff;
  border: 1px solid var(--info);
}

.warning {
  background: #fff6e5;
  border: 1px solid var(--warning);
}

.error {
  background: #ffe9ea;
  border: 1px solid var(--danger);
}
